import type { PreviewBasedState } from "@/types";

export default <T>(data: T): PreviewBasedState<T> => {
  return {
    state: structuredClone(data),
    preview: structuredClone(data),
  };
};
